import React from 'react'
import { SignInButton } from '../auth-components/SignInButton'

function Unauthorized() {
  return (
    <div className='unauthorized' >
      <span className='unauthorized-text'>
        Please connect to use this tool
      
      <br />
      <SignInButton />
        </span>
    </div>
  )
}

export default Unauthorized